/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item3Inputs */

const tr_hakkimizda_s3_item3 = /** @type {(inputs: Hakkimizda_S3_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM şifrelenmiş API anahtarı saklama`)
};

const en_hakkimizda_s3_item3 = /** @type {(inputs: Hakkimizda_S3_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM encrypted API key storage`)
};

const de_hakkimizda_s3_item3 = /** @type {(inputs: Hakkimizda_S3_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM verschlüsselte Speicherung von API-Schlüsseln`)
};

const ru_hakkimizda_s3_item3 = /** @type {(inputs: Hakkimizda_S3_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранение API-ключей с шифрованием AES-256-GCM`)
};

/**
* | output |
* | --- |
* | "AES-256-GCM encrypted API key storage" |
*
* @param {Hakkimizda_S3_Item3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item3 = /** @type {((inputs?: Hakkimizda_S3_Item3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item3(inputs)
	if (locale === "de") return de_hakkimizda_s3_item3(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item3(inputs)
	return tr_hakkimizda_s3_item3(inputs)
});